import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RelewiseTypes } from '@core/services/relewise/relewise.config';
import { Carousel } from '@features/spots/umbraco-block-list-spot/block-list-spot.models';
import { RelewiseSliderComponent } from '../../slider/relewise-slider/relewise-slider.component';

@Component({
    selector: 'app-most-popular-in-category-slider',
    template: '<app-relewise-slider [type]="relewiseType" [categoryId]="data?.category" [headline]="data?.headlineText" [compressed]="data?.compressedLayout" [centerAlign]="data?.centerAligned"></app-relewise-slider>',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RelewiseSliderComponent]
})
export class MostPopularInCategorySliderComponent {
    public static readonly ref: string = 'mostPopularInCategoryCarousel';
    public relewiseType = RelewiseTypes.MostPopularByCategory;

    @Input()
    public data?: Carousel;
}
